import "./dockConfigDetails.js";
import "./dockLookup.js";
import "./newEditDock.js";
//import "./dockNewEdit.js";
//const targetSelector = "#p_p_id_channels_WAR_hcportlet_";
//const targetSelector = "#p_p_id_rmsui_WAR_rmsuiportlet_";
//const targetSelector = "#p-global-stubs-container";
//const targetSelector = "#p-global-ui-comps-container";
//const targetSelector = "#p-global-comps-container";



// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/index.js